import { capitalize } from "lodash/string";

function shouldAddToBreadCrumb(place) {
  return place.placeType !== "region" &&
    place.placeType !== "neighborhood";
}

function returnBreadcrumb(ancestry, place, narrative = null) {
  let breadcrumb = [];

  if (Array.isArray(ancestry)) {
    breadcrumb = ancestry
      .filter(shouldAddToBreadCrumb)
      .map((ancestor) => ({
        type: ancestor.placeType,
        href: `/places/${ancestor.id}`,
        title: ancestor.name,
        id: ancestor.id,
      }));
  } else if (place && place.ancestry) {
    breadcrumb.push({
      type: place.ancestry.placeType,
      title: place.ancestry.name,
      href: `/places/${place.ancestry.id}`,
      id: place.ancestry.id,
    });
  }

  if (place &&
    place.placeType !== "neighborhood" &&
    !breadcrumb.find(b => b.title === place.name)
  ) {
    breadcrumb.unshift({
      type: place.placeType,
      href: `/places/${place.id}`,
      title: place.name,
      id: place.id,
    });
  }

  if (narrative) {
    narrative.path.split("/").map((el) => {
      const formatted = el.replace(/\-/g, " ");

      breadcrumb.unshift({
        type: "narrative",
        title: capitalize(formatted),
        href: narrative.url,
      });
    });
  }

  return breadcrumb;
}

export default returnBreadcrumb;



// WEBPACK FOOTER //
// ../server/lib/helpers/breadcrumbs.js